import React from "react";
import { Login } from "@microsoft/mgt-react";
import {
  AppBar,
  Typography,
  Toolbar,
  Box,
  IconButton,
  Tooltip,
} from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import SailsImage from "../../images/Sails.png";
import mgtStyle from "../../style/mgtStyle.module.css";
import { config } from "../../config.js";

const PageHeader = ({ title }) => {
  return (
    <AppBar position="static" color="primary">
      <Toolbar>
        <img src={SailsImage} style={{ height: "40px", marginRight: "1rem" }} />
        <Typography variant="h2" sx={{ flexGrow: 1 }}>
          {title}
        </Typography>
        <Login className={mgtStyle.login} />
        <Tooltip title="Get help with this app">
          <IconButton
            color="default"
            onClick={() => {
              window.open(config.helpSiteUrl, "_blank");
            }}
          >
            <HelpOutlineIcon fontSize="large" />
          </IconButton>
        </Tooltip>
      </Toolbar>
    </AppBar>
  );
};

export default PageHeader;
